export const ok = (value) => ({ ok: true, value });
export const err = (error) => ({ ok: false, error });
export const isOk = (r) => r.ok;
export const isErr = (r) => !r.ok;
export const map = (r, f) => (isOk(r) ? ok(f(r.value)) : r);
export const mapErr = (r, f) => (isErr(r) ? err(f(r.error)) : r);
export const unwrapOr = (r, fallback) => isOk(r) ? r.value : fallback;
export const flatMap = (r, f) => (isOk(r) ? f(r.value) : r);
//# sourceMappingURL=result.js.map